import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../../api/client';
import { Button, DashboardCard, StatTile, Skeleton } from '../../ui';
import '../dashboard.css';

// insightsLink (decision 86, phone): "View insights →" in the card's header bar, right side.
// Decision 87: Workload's strip is peach, --pastel-peach (#ffe2c7, added for it).
const TINT = 'pastel-peach';

export default function PulseWidget({ onViewInsights, insightsLink }) {
  const [pulse, setPulse]     = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchPulse = useCallback(async () => {
    try {
      const res = await api('/api/pulse');
      if (res.ok) setPulse(await res.json());
    } catch (_) {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPulse();
    const id = setInterval(fetchPulse, 5 * 60 * 1000);
    return () => clearInterval(id);
  }, [fetchPulse]);

  const link = insightsLink ? (
    <button type="button" className="dash-bar-link ui-hit" onClick={insightsLink} data-testid="workload-insights-link">
      View insights <span aria-hidden="true">→</span>
    </button>
  ) : null;

  if (loading) {
    return (
      <DashboardCard tint={TINT} title="Workload" meta={link}>
        <Skeleton lines={3} label="Working out your workload" />
      </DashboardCard>
    );
  }

  // On a phone this card carries the only way to Insights, so it stays when the workload did not load.
  if (!pulse) {
    return insightsLink ? (
      <DashboardCard tint={TINT} title="Workload" meta={link}>
        <p className="dash-lead">Your workload did not load.</p>
      </DashboardCard>
    ) : null;
  }

  // The level's colour comes from the server with the label; the word carries the meaning.
  const meta = (
    <span className="dash-bar-meta">
      <span className="dash-dot" style={pulse.colour ? { '--ui-bg': pulse.colour } : undefined} aria-hidden="true" />
      {pulse.label}
      {link}
    </span>
  );

  return (
    <DashboardCard tint={TINT} title="Workload" meta={meta}>
      <p className="dash-lead">{pulse.summary}</p>
      {pulse.factors && (
        <div className="dash-stats">
          <StatTile label="Tasks due" value={pulse.factors.taskCount} />
          <StatTile label="Overdue" value={pulse.factors.overdueCount} />
          <StatTile label={pulse.factors.meetingCount === 1 ? 'Meeting' : 'Meetings'} value={pulse.factors.meetingCount} />
        </div>
      )}
      {/* Block B: the Business Dashboard offers Insights from its header instead. */}
      {onViewInsights && (
        <div className="dash-actions">
          <Button variant="tertiary" size="sm" onClick={onViewInsights}>View insights</Button>
        </div>
      )}
    </DashboardCard>
  );
}
